// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/emoji-mart/css/emoji-mart.css
// module id = 8286
// module chunks = 2